export type CleanStringRuleType = (value: string) => string;

export const normalizeWhitespace: CleanStringRuleType = (value) => {
    return value.replace(/\s+/g, ' ');
};

export const removeAllWhitespace: CleanStringRuleType = (value) => {
    return value.replace(/\s/g, '');
};

export const removeAllHyphens: CleanStringRuleType = (value) => {
    return value.replace(/-/g, '');
};

export const noHtmlTags: CleanStringRuleType = (value) => {
    return value.replaceAll('<br />', '\r\n').replaceAll('</b>', '').replaceAll('<b>', '');
};

export const backslashNToBreak: CleanStringRuleType = (value) => {
    return value.replaceAll(/\n/g, '<br />');
};
